<section>
  <ul class="prf-info-block-list">
    @for (infoBlock of infoBlockData; track infoBlock.id) {
      <prf-info-block-item [infoBlockItem]="infoBlock" />
    }
  </ul>
</section>
